import React from 'react';

import { DateTimePicker } from '@mui/x-date-pickers-pro';

import { Dayjs, parseDayjs } from '~/services/TimeService';

type Props = {
  value: string;
  onChange: (value: string) => void;
  label?: string | null;
  error?: boolean;
  helperText?: string;
  defaultTimezone?: string;
  showDateOnly?: boolean;
  disablePast?: boolean;
  disableFuture?: boolean;
  format?: string;
  disabled?: boolean;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  timeSteps?: { hours?: number; minutes?: number; seconds?: number };
  required?: boolean;
};

export default function DateTimeWidget({
  defaultTimezone = window.configs.DEFAULT_TIMEZONE,
  value,
  label,
  error,
  helperText,
  onChange,
  showDateOnly,
  disablePast,
  disableFuture,
  format,
  disabled,
  maxDate,
  minDate,
  timeSteps = { hours: 1, minutes: 5 },
  required,
}: Props) {
  const widgetLabel = label ? `${label} (${defaultTimezone})` : defaultTimezone;
  const widgetValue = parseDayjs(value).tz(defaultTimezone);

  const handleChange = (newValue: Dayjs | null) => {
    const value = newValue?.tz(defaultTimezone).format();
    onChange(value);
  };

  return (
    <DateTimePicker
      format={format}
      label={widgetLabel}
      value={widgetValue}
      onChange={handleChange}
      disablePast={disablePast}
      disableFuture={disableFuture}
      views={showDateOnly ? ['year', 'month', 'day'] : undefined}
      slotProps={{ textField: { fullWidth: true, required, error, helperText } }}
      maxDate={maxDate}
      minDate={minDate}
      disabled={disabled}
      timeSteps={timeSteps}
    />
  );
}
